<template>
  <div class="min-h-screen bg-white text-gray-800">
    <HeaderPage /> 
    <router-view />
    <FooterPage /> 
  </div>
</template>

<script>
import HeaderPage from './components/HeaderPage.vue'
import FooterPage from './components/FooterPage.vue'

export default {
  components: {
    HeaderPage,
    FooterPage
  }
}
</script>